query GetFields($entityType: EntityType!) {
    createModalFields(entityType: $entityType) {
        fieldId
        isRequired
        isRemoveable
        isBoardable
    }
}
